import React from 'react'
import { NavLink } from 'react-router-dom'

import * as S from './TabsItem.styled'
import type { Props } from './types'

export const TabsItem = ({ label, to }: Props) => {
  return (
    <S.Container as={NavLink} to={to}>
      {label}
    </S.Container>
  )
}
